import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

/**
 * Returns only the value(s) of dirty controls in a UntypedFormGroup.
 *
 * @param form - AbstractControl that needs to be checked.
 * @param withoutEnabled - Filter parameter, when true it removes active dirty field values from the result.
 * @param withoutDisabled - Filter parameter, when true it removes disabled dirty field values from the result.
 * @debt Ideally this method would return both active and disabled field values instead of only active values
 * and a way to filter this on the result set according to the needs.
 *
 * Since we have mixed responsibilities in this helper class we tried to add those filter posibilities to the params
 * so that it becomes possible to get only active dirty values and only disabled dirty values etc. Refactoring these
 * responsibilities was outside the scope of the story, but would be a good idea to solve via debt.
 */
export const getDirtyValue = (
	form?: AbstractControl,
	withoutEnabled = false,
	withoutDisabled = true,
): any | undefined => {
	if (!form || !form.dirty) {
		return;
	}

	if (form instanceof UntypedFormArray || form instanceof UntypedFormControl) {
		return form.value;
	}

	const result = {};
	const formGroup = form as UntypedFormGroup;
	const keys = Object.keys(formGroup.controls);

	for (const key of keys) {
		const control = formGroup.controls[key];

		if (!control.dirty || (withoutEnabled && !control.disabled) || (withoutDisabled && control.disabled)) {
			continue;
		}

		result[key] = control.value;
	}

	return result;
};
